var _a;
import * as Sentry from "@sentry/browser";
import { default as React } from "react";
import "react-app-polyfill/ie11";
import * as ReactDOM from "react-dom/client";
import smoothscroll from "smoothscroll-polyfill";
import { getArea } from "../shared/getArea";
import ClassList from "./components/ClassList";
// kick off the polyfill!
smoothscroll.polyfill();
Sentry.init({
    dsn: process.env.SENTRY_DSN,
    release: process.env.VERSION,
});
const ele = document.getElementById("class-list");
if (ele) {
    const root = ReactDOM.createRoot(ele);
    root.render(React.createElement(ClassList, { area: getArea(), place: (_a = ele === null || ele === void 0 ? void 0 : ele.dataset.placeList) !== null && _a !== void 0 ? _a : "" }));
}
